import { ConfigData } from 'serviceWorker/db/config';
import {
  defaultConfig,
  generateHeaders,
  parseResponse,
} from 'serviceWorker/helpers/httpRequests';
import { pull } from '../pull';

export interface FetchDocumentUrlOptions {
  forceRefresh?: boolean;
}

export function fetchDocumentUrl(
  data: ConfigData,
  fullUrl: string,
  options?: FetchDocumentUrlOptions
): Promise<any> {
  const config = {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
  };
  config.cache = options?.forceRefresh ? 'no-store' : 'default';
  return pull(fullUrl, config).then(parseResponse);
}
